<script setup></script>

<template>
    <div class="text-2x font-semibold">
        Sorry something went wrong. This page is currently unavailable.
    </div>
</template>
